module.exports = __webpack_public_path__ + "static/july2017headshot.1a50058e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/july2017headshot.jpeg
// module id = 1091
// module chunks = 35783957827783